export default __webpack_public_path__ + "static/media/category-smile.efb1d395.svg";